import * as Highcharts from "highcharts"
import { applyHighchartsTheme } from "../utils/highcharts_theme"

// Get locale from server-provided I18n config (set once on page load)
function getLocale() {
  return window.I18n?.numberFormat?.locale || "en"
}

// Lazy-initialized date formatter
let monthYearFormatter = null

function getMonthYearFormatter() {
  if (!monthYearFormatter) {
    monthYearFormatter = new Intl.DateTimeFormat(getLocale(), {
      month: "long",
      year: "numeric",
    })
  }
  return monthYearFormatter
}

function lastMonthTime() {
  const date = new Date()
  date.setDate(1)
  date.setMonth(date.getMonth() - 1)
  return date.getTime()
}

function prepareData(data) {
  return data.map((item) => {
    const month = new Date(item.date).getTime()

    return {
      x: month,
      y: parseFloat(item.count),
    }
  })
}

export const ProspectMeetingGraph = {
  mounted() {
    this.data = JSON.parse(this.el.dataset.prospectMeeting)
    this.showChart()
  },

  updated() {
    this.data = JSON.parse(this.el.dataset.prospectMeeting)
    this.showChart()
  },

  showChart() {
    // Prepare the data for Highcharts
    const lastMonth = lastMonthTime()

    console.log(this.data)
    const meetingData = prepareData(this.data)

    applyHighchartsTheme(Highcharts)

    Highcharts.chart(this.el, {
      title: null,
      chart: {
        type: "area",
        backgroundColor: null,
      },
      plotOptions: {
        series: {
          zoneAxis: "x",
          zones: [{ value: lastMonth }, { dashStyle: "Dash" }],
        },
      },
      legend: {
        enabled: true,
        align: "center",
        verticalAlign: "top",
        floating: true,
        padding: 5,
        itemStyle: {
          fontWeight: "normal",
          fontSize: "14px",
        },
      },
      credits: {
        enabled: false,
      },
      xAxis: {
        type: "datetime",
        lineWidth: 0,
        labels: {
          style: {
            fontSize: "12px",
          },
          formatter: function () {
            return new Intl.DateTimeFormat(getLocale(), {
              month: "short",
              year: "numeric",
            }).format(this.value)
          },
        },
      },
      yAxis: {
        title: null,
        allowDecimals: false,
        labels: {
          style: {
            fontSize: "12px",
          },
        },
      },
      series: [
        {
          name: this.el.dataset.seriesLabel || "Meeting",
          data: meetingData,
          color: "#FF6600",
          marker: {
            fillColor: "#FF6600",
            radius: 4,
          },
        },
      ],
      tooltip: {
        shared: true,
        crosshairs: true,
        style: {
          fontSize: "14px",
        },
        formatter: function () {
          return (
            getMonthYearFormatter().format(this.x) +
            "<br>" +
            this.points
              .map(
                (point) =>
                  `<span style="color:${point.series.color}">\u25CF</span> ${point.series.name}: <b>${point.y}</b>`,
              )
              .join("<br>")
          )
        },
      },
    })
  },
}
